<template>
  <div v-if="stockOrderIn && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint :formater="formater" :data="stockOrderIn" />
  </div>
</template>
<script>
import StockIns from "@/api/stock_ins";
import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";
import { mapState } from "vuex";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    stockOrderIn: {},
  }),
  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountInfo"]),
  },
  mounted() {
    if (
      this.accountInfo &&
      this.accountInfo.account_id == "021751" &&
      this.$route.query.type == 11
    ) {
      //021751品牌且为采购入库单
      PrintTemplates.fetchOne("purchaseStockOrderIn").then(
        function (response) {
          if (response.data.status.isOK()) {
            var formater = response.data.print_template.template;
            this.formater = formater;

            //获取单据详情
            StockIns.stockOrderInPrint(this.$route.params.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.stockOrderIn = response.data.stock_in;
                  this.stockOrderIn.stock_order_details =
                    this.stockOrderIn.stock_order_details.map((detail) => {
                      if (detail.negotiate_price_flg == 1) {
                        // 显示后议价
                        detail.price = this.$t(
                          "PurchasesDetail.purchaseFields.negotiatePrices"
                        );
                      }
                      return detail;
                    });
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    
    } else {
      PrintTemplates.fetchOne("stockOrderIn").then(
        function (response) {
          if (response.data.status.isOK()) {
            var formater = response.data.print_template.template;
            this.formater = formater;

            //获取单据详情
            StockIns.stockOrderInPrint(this.$route.params.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.stockOrderIn = response.data.stock_in;
                  this.stockOrderIn.stock_order_details =
                    this.stockOrderIn.stock_order_details.map((detail) => {
                      if (detail.negotiate_price_flg == 1) {
                        // 显示后议价
                        detail.price = this.$t(
                          "PurchasesDetail.purchaseFields.negotiatePrices"
                        );
                      }
                      return detail;
                    });
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    }
  },
};
</script>